module.exports = __webpack_public_path__ + "static/media/alum_vert.09c24b46.png";